import { IBAN, TRANSFER_CERTIFICATE } from 'constants/identityMethod';

const identityMethodsToChangeStatusUser = [IBAN, TRANSFER_CERTIFICATE];

export const checkIfIdentityMethodNeedsToCheckUserStatus = identityMethod =>
    identityMethodsToChangeStatusUser.includes(identityMethod);
